export default __webpack_public_path__ + "static/media/spinner-gradient.3134cad9.svg";